import React, { createContext, useContext, useState } from 'react';
import { getUser } from '../api/usersController';

const UserContext = createContext();
export const useUser = () => {
  const context = useContext(UserContext);

  if (context === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }

  const reload = async () => {
    const data = await getUser();
    context.setUser(data);
  };

  // Extend the context value with hasPermission method
  return {
    ...context,
    reload,
  };
};


export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};
